<script setup lang="ts">
import { EbomPartSnoozeStatus } from '@/generated/graphql'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  status: EbomPartSnoozeStatus
}>()
const hasArticleNumberPath = computed(() => props.status != EbomPartSnoozeStatus.None)
const hasRevision = computed(
  () =>
    props.status == EbomPartSnoozeStatus.PathArticleRevision ||
    props.status == EbomPartSnoozeStatus.PathArticleRevisionQuantity,
)
const hasQuantity = computed(() => props.status == EbomPartSnoozeStatus.PathArticleRevisionQuantity)
const { t } = useI18n()
</script>

<template>
  <v-icon v-if="!hasArticleNumberPath" :title="t('component.iconEbomPartSnoozeStatus.notSnoozed')">
    alarm
  </v-icon>
  <template v-if="hasArticleNumberPath">
    <v-icon :title="t('component.iconEbomPartSnoozeStatus.snoozed')">alarm_off</v-icon>
    <v-icon :title="t('component.iconEbomPartSnoozeStatus.matchesArticleNumberAndPath')">
      lan
    </v-icon>
    <v-icon
      :title="
        t(
          `component.iconEbomPartSnoozeStatus.${hasRevision ? 'matchesRevision' : 'notMatchesRevision'}`,
        )
      "
      :disabled="!hasRevision"
    >
      change_circle
    </v-icon>
    <v-icon
      :title="
        t(
          `component.iconEbomPartSnoozeStatus.${hasQuantity ? 'matchesQuantity' : 'notMatchesQuantity'}`,
        )
      "
      :disabled="!hasQuantity"
    >
      123
    </v-icon>
  </template>
</template>

<style scoped lang="scss"></style>
